var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getTextLinkSx = function (color, sizeVariant) {
    var fontStyle = sizeVariant === 'xxxxs'
        ? bodyLinkSmallTextSx
        : sizeVariant === 'xxxs'
            ? bodyLinkMediumTextSx
            : bodyLinkLargeTextSx;
    var colorStyle = getColorStyles(color !== null && color !== void 0 ? color : 'primary');
    return __assign(__assign({}, fontStyle), colorStyle);
};
var getColorStyles = function (color) {
    var secondaryColor = color === 'black'
        ? 'gray-70'
        : color === 'error'
            ? 'red-70'
            : 'violet-70';
    return {
        color: color,
        transition: 'color .15s ease-in',
        '&:link, &:visited': {
            transition: 'color .15s ease-in',
        },
        '&:hover': {
            transition: 'color .15s ease-in',
            color: secondaryColor,
        },
        '&:active': {
            transition: 'color .15s ease-in',
            color: secondaryColor,
        },
        '&:focus-visible': {
            borderRadius: 1,
            outlineStyle: 'solid',
            outlineColor: 'divider-dark',
            outlineWidth: '1px',
            outlineOffset: '4px',
        },
        '@media screen and (-ms-high-contrast: active),\r\n        screen and (-ms-high-contrast: none)': {
            '&:hover, &:focus': {
                textDecoration: 'underline',
            },
        },
    };
};
var commonLinkTextSx = {
    textDecoration: 'underline',
    textAlign: 'center',
    fontFamily: 'body',
    fontStyle: 'normal',
    fontWeight: 5,
};
var bodyLinkSmallTextSx = __assign(__assign({}, commonLinkTextSx), { fontSize: 0, lineHeight: '16.34px' });
var bodyLinkMediumTextSx = __assign(__assign({}, commonLinkTextSx), { fontSize: 1, lineHeight: '19.07px' });
var bodyLinkLargeTextSx = __assign(__assign({}, commonLinkTextSx), { fontSize: 2, lineHeight: '21.79px' });
